import { render } from "./ShowProfileComponent.vue?vue&type=template&id=f9c36b28&scoped=true"
import script from "./ShowProfileComponent.vue?vue&type=script&lang=js"
export * from "./ShowProfileComponent.vue?vue&type=script&lang=js"

import "./ShowProfileComponent.vue?vue&type=style&index=0&id=f9c36b28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9c36b28"

export default script